// Synchronous WebGL detection. Tries to create a small test canvas,
// then immediately discards it. Stable across React strict-mode
// double-invoke.

let cached: boolean | null = null;

export function useWebGLAvailable(): boolean {
  if (cached !== null) return cached;
  if (typeof window === 'undefined') {
    cached = false;
    return false;
  }
  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl2') ||
      canvas.getContext('webgl') ||
      canvas.getContext('experimental-webgl');
    cached = !!gl;
  } catch {
    cached = false;
  }
  return cached;
}
